import { call, put, takeLatest } from 'redux-saga/effects'
import { t } from 'i18next'
import apiCall from '../helpers/apiCall'
import { POST } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  SYNC_CHANNEL_ACTIVATION,
  SYNC_CHANNEL_ACTIVATION_FAILURE,
  SYNC_CHANNEL_ACTIVATION_SUCCESS
} from 'src/redux/integrationsReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'

interface SyncChannelActivationAction {
  payload: { id: number }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* SyncChannelActivationFlow(action: SyncChannelActivationAction): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    yield call(apiCall, {
      endpoint: `/dealers_api/channel_activations/${action.payload.id}/sync`,
      api: 'market-api',
      method: POST,
      params: {}
    })
    yield put(SYNC_CHANNEL_ACTIVATION_SUCCESS())
    yield put(
      SHOW_TOAST({
        message: t('integrations_screen.sync_started'),
        actionLabel: t('my_vehicles.title'),
        actionPath: '/selling/vehicles'
      })
    )
  } catch (error) {
    yield put(SYNC_CHANNEL_ACTIVATION_FAILURE())
    yield put(SHOW_TOAST({ message: t('integrations_screen.sync_error') }))
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* SyncChannelActivationSaga(): Generator<any, void, any> {
  yield takeLatest(SYNC_CHANNEL_ACTIVATION, SyncChannelActivationFlow)
}
